import { render, staticRenderFns } from "./EventsList.vue?vue&type=template&id=0a89a150&scoped=true"
import script from "./EventsList.vue?vue&type=script&lang=ts"
export * from "./EventsList.vue?vue&type=script&lang=ts"
import style0 from "./EventsList.vue?vue&type=style&index=0&id=0a89a150&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a89a150",
  null
  
)

export default component.exports